import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  /**
   *
   */
  public readonly emailTarget = 'OR-NBG-DSS-DTIS-IoT-Services-Support@schaeffler.com';
  /**
   *
   */
  public readonly emailDefaultSubject = `[WebUI] Support Request ${new Date().toUTCString()}`;

  public sendSupportRequest(message: string) {
    // as workaround create and simulation anchor element with mailto:// link
    const list = `mailto://${this.emailTarget}?subject=${this.emailDefaultSubject}&body=${message}`;
    try {
      window.open(list, '_blank');
    } catch (error) {
      console.error(error);
    }
  }
}
